module.exports = __webpack_public_path__ + "static/logo-9a23634c3e183523aabe202995177b3f.png";